// Gamepad API → synthetic keyboard events (D-pad / left stick / face buttons).
const KEY_MAP = { 12: "ArrowUp", 13: "ArrowDown", 14: "ArrowLeft", 15: "ArrowRight", 0: "Enter", 1: "Escape" };
const AXIS_REPEAT_MS = 260;

export function initGamepad() {
  let raf = null;
  const prev = {};
  const lastAxis = { tx: 0, ty: 0 };

  const dispatch = (key) =>
    window.dispatchEvent(new KeyboardEvent("keydown", { key, bubbles: true }));

  const poll = () => {
    const pads = navigator.getGamepads ? [...navigator.getGamepads()].filter(Boolean) : [];
    if (!pads.length) {
      raf = null;
      return;
    }
    const now = performance.now();
    for (const p of pads) {
      p.buttons.forEach((b, i) => {
        const id = `${p.index}-${i}`;
        if (b.pressed && !prev[id] && KEY_MAP[i] !== undefined) dispatch(KEY_MAP[i]);
        prev[id] = b.pressed;
      });
      const x = p.axes[0] || 0;
      const y = p.axes[1] || 0;
      if (Math.abs(x) > 0.6 && now - lastAxis.tx > AXIS_REPEAT_MS) {
        dispatch(x > 0 ? "ArrowRight" : "ArrowLeft");
        lastAxis.tx = now;
      }
      if (Math.abs(y) > 0.6 && now - lastAxis.ty > AXIS_REPEAT_MS) {
        dispatch(y > 0 ? "ArrowDown" : "ArrowUp");
        lastAxis.ty = now;
      }
    }
    raf = requestAnimationFrame(poll);
  };

  const start = () => {
    if (!raf) raf = requestAnimationFrame(poll);
  };

  window.addEventListener("gamepadconnected", start);
  start();
  return () => {
    window.removeEventListener("gamepadconnected", start);
    if (raf) cancelAnimationFrame(raf);
  };
}
